import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { Table } from "../../../../components/ui";
import usePagination from "../../../../hooks/usePagination";
import { appendSearchParamsToQuery } from "../../../ComplianceSearch/utils";
import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { HELIOS_AND_APPIUS_LIVE_TIF_COLUMNS } from "../../../ComplianceSearch/constants";
import { fundedComplianceProfileActions } from "../../../../reducers/fundedComplianceProfile";

const HeliosAppiusKronosLiveTif: React.FC = () => {
  const dispatch = useDispatch();
  const pagination = usePagination();
  const params: { id: string } = useParams();
  const { data, isLoading } = useSelector(
    (state) => state.fundedComplianceProfile.heliosAppiusKronosLiveTif
  );

  const search = { compliance_entries_id: params.id };

  const { isError, error } = useQuery({
    queryKey: [
      COMPLIANCE_API_URLS.getWatchlistHeliosAppiusLiveTif,
      Object.values(search),
      pagination.page,
      pagination.limit,
    ],
    async queryFn({ signal }) {
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());
      appendSearchParamsToQuery(search, query);

      dispatch(fundedComplianceProfileActions.fetchHelAppKrLiveTifRequest());
      const response = await ComplianceAPI.getWatchlistHeliosAppiusLiveTifRequest(
        query.toString(),
        signal
      );
      dispatch(fundedComplianceProfileActions.fetchHelAppKrLiveTifSuccess(response.data));

      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(fundedComplianceProfileActions.fetchHelAppKrLiveTifFailed());
      console.error("Error fetch fetchWatchlistHeliosAppiusLiveTifRequest", error);
    }
  }, [isError, error]);

  useEffect(() => pagination.setPage(0), [search, pagination.limit]);

  const csv_table_name = `Helios/Appius/Kronos Live TIF entry ID: ${params.id}`;
  return (
    <Table
      columns={HELIOS_AND_APPIUS_LIVE_TIF_COLUMNS}
      loading={isLoading}
      pagination={pagination}
      extractKey={(row) => row.id + row.timestamp}
      data={data.rows}
      theadTitle="Helios/Appius/Kronos Live TIF"
      noResultsMessage="There are no Helios/Appius/Kronos Live TIF records"
      csv_table_name={csv_table_name}
    />
  );
};

export default HeliosAppiusKronosLiveTif;
